module.exports = __webpack_public_path__ + "static/media/email-bg.351fe8ce.png";